import {ActionReducer} from '@ngrx/store';
import {logoutSuccess} from '../modules/authentication/store/authentication.actions';
import {AppState} from './app.reducers'

export function clearStateMetaReducer(
  reducer: ActionReducer<AppState>
): ActionReducer<AppState> {
  return function (state, action) {
    if (action.type === logoutSuccess.type) {
      return reducer(undefined, {type: '[App] Reset'}); // <-- reset totale
    }
    return reducer(state, action);
  };
}
